export const TERMS_LAST_UPDATED = '2024-01-16T03:20:00.559Z';
export const LINK_ADV2A = 'https://adv2a.kessler.energy/'
export const LINK_ADV2B = 'https://adv2b.kessler.energy/'
export const LINK_AGREEMENT = 'https://agreement.kessler.energy/'
